"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconClient = void 0;
const exposed_promise_1 = require("../../utils/exposed-promise");
const generate_uuid_1 = require("../../utils/generate-uuid");
const crypto_1 = require("../../utils/crypto");
const __1 = require("../..");
const events_1 = require("../../events");
const constants_1 = require("../../constants");
class BeaconClient {
    constructor(config) {
        this._beaconId = new exposed_promise_1.ExposedPromise();
        this.events = new events_1.BeaconEventHandler();
        this._keyPair = new exposed_promise_1.ExposedPromise();
        this.name = config.name;
        this.storage = config.storage;
        this.storage.set(__1.StorageKey.BEACON_SDK_VERSION, constants_1.SDK_VERSION).catch(console.error);
        this.loadOrCreateBeaconSecret().catch(console.error);
        this.keyPair
            .then((keyPair) => {
            this._beaconId.resolve(crypto_1.toHex(keyPair.publicKey));
        })
            .catch(console.error);
    }
    get beaconId() {
        return this._beaconId.promise;
    }
    get keyPair() {
        return this._keyPair.promise;
    }
    async loadOrCreateBeaconSecret() {
        const storageValue = await this.storage.get(__1.StorageKey.BEACON_SDK_SECRET_SEED);
        if (storageValue && typeof storageValue === 'string') {
            this._keyPair.resolve(await crypto_1.getKeypairFromSeed(storageValue));
        }
        else {
            const key = generate_uuid_1.generateGUID();
            await this.storage.set(__1.StorageKey.BEACON_SDK_SECRET_SEED, key);
            this._keyPair.resolve(await crypto_1.getKeypairFromSeed(key));
        }
    }
}
exports.BeaconClient = BeaconClient;
//# sourceMappingURL=BeaconClient.js.map